import { Component, Inject, Input, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { ContactUsModel } from '../../models/contact-us.model';
import { ConversationModel } from '../../models/conversation.model';
import { SecureMessagingService } from '../../services/secure-messaging.service';

@Component({
	selector: 'chat-panel',
	templateUrl: './chat-panel.component.html',
	styleUrls: ['./chat-panel.component.scss'],
	standalone: false
})
export class ChatPanelComponent implements OnInit, AfterViewInit {
	@Input()
	selectedConversation: ConversationModel;

	@Input()
	healthTrackMode: boolean = false;

	public newMessageForm: FormGroup;

	public loadingData = {
		//fetchAccounts: false,
		//fetchMessages: false,
		//fetchMessageSubjects: false,
		//fetchConvResponseTypes: false,
		sendingMessage: false
	};

	public snackBarMessage: MatSnackBarRef<SimpleSnackBar>;

	constructor(
		private formBuilder: FormBuilder,
		@Inject('securityService') public securityService: any,
		private secureMessagingService: SecureMessagingService,
		private snackBar: MatSnackBar
	) {}

	ngOnInit(): void {
		this.buildForm();
	}

	ngAfterViewInit() {}

	private buildForm() {
		this.newMessageForm = this.formBuilder.group({
			message: [null, [Validators.required]]
		});
	}

	public sendMessage() {
		if (!this.isFormInvalid()) {
			this.loadingData.sendingMessage = true;
			const model = new ContactUsModel();
			model.conversationId = this.selectedConversation.conversationId;
			if (!this.healthTrackMode) {
				model.messageEntityNameId = this.selectedConversation.withEntityNameId;
				model.messageEntityId = this.selectedConversation.withEntityId;
			} else {
				model.messageEntityNameId = 1; //TODO MAGIC NUMBER
				model.messageEntityId = this.securityService.getCurrentUser().userId;
			}
			model.message = this.newMessageForm.get('message').value;
			this.secureMessagingService
				.saveMessage(model)
				.toPromise()
				.then(async () => {
					//await this.getMessages();
					//this.selectedConversation = this.conversations.find(t => t.conversationId == model.conversationId);
					this.newMessageForm.reset();
				})
				.catch((data) => {
					this.snackBarMessage = this.snackBar.open(data.error.message, 'DISMISS');
				})
				.finally(() => {
					this.loadingData.sendingMessage = false;
				});
		}
	}

	private isFormInvalid() {
		//
		if (this.newMessageForm.invalid) {
			this.newMessageForm.controls['message'].markAsTouched();
			return true;
		} else return false;
	}
}
